export enum PrescriptionSort {
  validityDate = 'validityDate'
}
